<template>
    <v-content :style="mini  ? 'padding: 0px 0px 0px 80px;' : 'padding: 64px 0px 0px 256px;'" >
        <v-container class="mt-n8" fluid style="position: relative">
            <v-col cols="12">
                <v-card raised>
                  <div class="iframe-container" style="overflow: hidden; padding-top: 47.00%; position: relative;">
                    <iframe id="iframemodule" :src="completeurl" style="border: 0;height: 100%;left: 0; position: absolute; top: 0; width: 100%;" allowfullscreen></iframe>
                  </div>
                  <v-btn
                    dark
                    fab
                    fixed
                    bottom
                    right
                    large
                    :color="primary_color"
                    class="mx-2"
                    v-if="currentUser.roles.includes(5)"
                    @click="openReportDialog"
                  >
                    <v-icon>mdi-bug</v-icon>
                  </v-btn>
                </v-card>
            </v-col>
        </v-container>
        <Dialogbox
          @redirect="redirect"
          :title="dialogboxtitle"
          :dialog="dialogstatus"
          :buttonTitle="dialogButtontitle"
          :closestatus='false'
          :redirect="true"
          v-if="dialogstatus"
        />
        <v-dialog v-model="reportDialogStatus" max-width="500">
          <v-card>
            <v-card-title class="headline">{{ 'Report Issue' | translate }}</v-card-title>
            <v-card-text>
            <v-form id="bugForm" ref="bugForm" lazy-validation>
              <v-row v-if="errors">
                <v-col cols="12" sm="12" md="12">
                  <v-alert
                    dense
                    v-for="(v, k) in errors"
                    :key="k"
                    outlined
                    type="error"
                  >{{ k }} {{ v }}</v-alert>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12">
                  <v-text-field
                    v-model="slideid"
                    name="slideid"
                    :rules="[v => !!v || 'Slide id is required']"
                    :label=" 'Slide Id' | translate"
                    readonly
                    required
                  >
                  <template #message="{ message }">
                    {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                  </template>
                  </v-text-field>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" sm="12">
                  <v-textarea
                    outlined
                    name="message"
                    v-model="reportmessage"
                    :rules="[v => !!v || 'Message is required']"
                    :label=" 'Message' | translate"
                  >
                  <template #message="{ message }">
                    {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                  </template>
                  </v-textarea>
                </v-col>
              </v-row>

              <v-checkbox v-model="sendCopy" :label="'Send copy to myself' | translate"></v-checkbox>
            </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>

              <v-btn color="primary darken-1" text @click="closeReportDialog()">{{ 'Close' | translate}}</v-btn>

              <v-btn color="primary darken-1" text @click="saveReport()">{{ 'Submit' | translate }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
    </v-content>
</template>

<script>
import { CourseFeedbackService } from "@/common/api.service";
import { mapGetters } from "vuex";
import store from "@/store";
import { FETCH_INDIVIDUAL_MODULE, SAVE_USER_SLIDE_ID, RESET_STATE } from "@/store/actions.type";
import { SET_LOADING, SET_SNACKBAR ,SET_ROUTER_ENTER } from "@/store/mutations.type"
export default {
  name: "ModulesDetails",
  async beforeRouteUpdate(to, from, next) {
    await store.dispatch(RESET_STATE);
    return next();
  },
  async beforeRouteEnter(to, from, next) {
    await store.dispatch(RESET_STATE);
    await store.dispatch(FETCH_INDIVIDUAL_MODULE,'tester-module/'+to.params.id+'?course_id='+to.query.course_id);
    store.commit(SET_ROUTER_ENTER, false)

    return next();
  },
  async beforeRouteLeave(to, from, next) {
    await store.dispatch(RESET_STATE);
    next();
  },
  components: {
    Dialogbox: () => import("@/components/dialog/dialog")
  },
  computed: {
    ...mapGetters(["currentUser","individualmodule", "widthValue", 'mini', 'curLanguage']),
  },
  mounted () {
      if(!this.currentUser.roles.includes(5)){
        this.$router.push("/drafts");
      }
      else if(this.individualmodule.show_player === false) {
            this.dialogstatus=true
            this.dialogboxtitle = 'Please subscribe to course'
            this.dialogButtontitle  = 'Go to courses'
            this.$store.commit(SET_LOADING, false)
      }
			if (window['postMessage']){
				if (window.addEventListener) {
					window.addEventListener('message', this.ReceiveMessage, false);
				}
				else {
					window.attachEvent('onmessage', this.ReceiveMessage);
				}
			}
      let company_meta  = JSON.parse(this.currentUser.company.company_meta)
      this.primary_color  = company_meta.primary_color
      this.token = encodeURIComponent('Basic '+process.env.VUE_APP_LEARNING_LOCKER_TEST_AUTH)
      this.path = this.individualmodule.module_versions.full_path
      this.endpoint = encodeURIComponent(process.env.VUE_APP_LEARNING_LOCKER)
      this.actor = encodeURIComponent('{"mbox":"'+this.currentUser.username+'@learnndt.com","name":"Tester","objectType":"Agent"}')
      this.completeurl = this.currentUser.roles.includes(5) ?  process.env.VUE_APP_PLAYER_URL+this.path+'?endpoint='+this.endpoint+'&auth='+this.token+'&actor='+this.actor : ''
 },
 methods :{
      saveReport () {
        if (this.$refs.bugForm.validate()) {
          CourseFeedbackService.post('',{
              slide_id: this.slideid,
              message: this.reportmessage,
              module_id: this.individualmodule.module_id,
              send_copy: this.sendCopy
            })
            .then(resp => {
              if (resp.data != undefined && resp.data.hasOwnProperty('success') && resp.data.success) {
                this.message = "Bug sent successfully";
                this.$store.commit(SET_SNACKBAR, {status: true, message: this.message })
                this.$store.commit(SET_LOADING, false);
                this.closeReportDialog();
              }
            })
            .catch(error => {
                this.errors = error.response.data.errors;
                this.$store.commit(SET_LOADING, false);
            })
        }
      },
      openReportDialog () {
        this.reportDialogStatus = true;
      },
      redirect(){
        this.$router.push('/courses')
      },
      closeReportDialog () {
        this.message = '';
        this.errors = {};
        this.sendCopy = false;
        this.reportDialogStatus = false;
      },
			ReceiveMessage(evt) {
				if (evt.origin === process.env.VUE_APP_PLAYER_URL&& this.slideid != (JSON.parse(evt.data).slideid))
				{
          this.slideid  = JSON.parse(evt.data).slideid
          this.$store.dispatch(SAVE_USER_SLIDE_ID,{
            course_id: localStorage.getItem("lastCourseVisitedId"),
            slide_id: this.slideid,
            module_id: this.individualmodule.module_id}).then(resp =>{
            if(resp.success == true){
              store.commit(SET_LOADING, false)
            }
          })
				}
      }
 },
  data() {
    return {
        token: null,
        path: null,
        endpoint: null,
        completeurl: null,
        actor:null,
        slideid: null,
        dialogstatus: false,
        dialogButtontitle: null,
        dialogboxtitle: null,
        primary_color: '',
        reportDialogStatus: false,
        reportmessage: '',
        message: '',
        errors: {},
        sendCopy: false,
    };
  },
}
</script>
